import {
  fieldContainer,
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const TextAreaInput = ({
  className,
  defaultValue,
  error,
  label,
  name,
  value,
  required = false,
  type = "text",
  register,
  readOnly = false,
  disabled = false,
  ...props
}) => {
  return (
    <div className={`${fieldContainer} ${className || ""}`}>
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <textarea
        type={type}
        id={name}
        className={`${fieldControlBase} ${error ? fieldControlError : ""}`}
        placeholder={props.placeholder || ""}
        {...register(name, { required })}
        value={value}
        defaultValue={defaultValue}
        readOnly={readOnly}
        disabled={disabled}
        {...props}
        rows={4}
      />

      {error && <small className={fieldErrorText}>{error}</small>}
    </div>
  );
};

export default TextAreaInput;
  